import { server } from "../utils/server";

const getWalletSummary = () => {
  return server
    .get("/investor/wallet/summary")
    .then((res) => res.data)
    .catch((err) => err?.response?.data || { success: false, message: "Network error" });
};

const getWalletFrozen = ({ page = 1, pageSize = 20 } = {}) => {
  return server
    .get(`/investor/wallet/frozen-breakdown?page=${page}&pageSize=${pageSize}`)
    .then((res) => res.data)
    .catch((err) => err?.response?.data || { success: false, message: "Network error" });
};

const getWalletLedger = ({ type, pool, search, status, page = 1, pageSize = 20 } = {}) => {
  const qp = new URLSearchParams();
  if (type) qp.set("type", type);
  if (pool) qp.set("pool", pool);
  if (search) qp.set("search", search);
  if (status) qp.set("status", status);
  qp.set("page", String(page));
  qp.set("pageSize", String(pageSize));

  return server
    .get(`/investor/wallet/ledger?${qp.toString()}`)
    .then((res) => res.data)
    .catch((err) => err?.response?.data || { success: false, message: "Network error" });
};

const reinvestPreview = ({ listingId, fracs }) => {
  return server
    .post("/investor/wallet/reinvest/preview", { listingId, fracs })
    .then((res) => res.data)
    .catch((err) => err?.response?.data || { success: false, message: "Network error" });
};

const withdraw = ({ netReceivable, amount, bankAccountId }) => {
  return server
    .post("/investor/wallet/withdraw", { netReceivable, amount, bankAccountId })
    .then((res) => res.data)
    .catch((err) => err?.response?.data || { success: false, message: "Network error" });
};

const createDepositOrder = ({ amount, userId }) => {
  return server
    .post(`/investor/wallet/deposit/rz/${userId}`, { amount })
    .then((res) => res.data)
    .catch((err) => err?.response?.data || { success: false, message: "Network error" });
};

const depositBankTransfer = ({ amount, bankAccountId, chequeNo, dateOfTransaction}) => {
  return server
    .post("/investor/wallet/deposit/bank", { amount, paymentMethod: "DBT", bankAccountId, chequeNo, dateOfTransaction })
    .then((res) => res.data)
    .catch((err) => err?.response?.data || { success: false, message: "Network error" });
};

const initiateUPI = ({ amount}) => {
  return server
    .post("/investor/wallet/initiate/upi", { amount, paymentMethod: "UPI" })
    .then((res) => res.data)
    .catch((err) => err?.response?.data || { success: false, message: "Network error" });
};

const depositUPI = ({ walletTransactionId }) => {
  return server
    .post("/investor/wallet/deposit/upi", { walletTransactionId })
    .then((res) => res.data)
    .catch((err) => err?.response?.data || { success: false, message: "Network error" });
};

const walletServices = {
  getWalletSummary,
  getWalletFrozen,
  getWalletLedger,
  reinvestPreview,
  withdraw,
  createDepositOrder,
  depositBankTransfer,
  initiateUPI,
  depositUPI
};

export default walletServices;

